import { IActivityHistoryDiagnostic } from "../../model";

export const areSameDiagnostics = (
  diag1: IActivityHistoryDiagnostic[],
  diag2: IActivityHistoryDiagnostic[],
): boolean => {
  if (diag1.length !== diag2.length) {
    return false;
  }

  const sortedDiag1 = diag1.map((d) => d.codi).sort();
  const sortedDiag2 = diag2.map((d) => d.codi).sort();

  return sortedDiag1.every((id, index) => id === sortedDiag2[index]);
};
